<template>
    <div class="wt-container">
        <p v-if="!assessment.crop" class="introduction-text">
            Please select a crop or a crop category.
        </p>
        <p v-else-if="assessment.crop.cropID > 10000" class="introduction-text">
            This function does not work at the sector level. Please select a crop or a crop category.
        </p>
        <p v-else-if="assessment.crop.cropID == 1009" class="introduction-text">
            This function does not work for fodder crops. Please select another crop or crop category.
        </p>
        <div v-else>
            <p class="introduction-text">
                This table shows the {{assessment.viewColor}} water footprint of {{assessment.crop.name.toLowerCase()}} in {{assessment.getCountryOrBasinName(true)}}, its efficiency and sustainability, per {{countryOrBasinText}}.
            </p>
            <Table :columns="columns" :rows="rows"></Table>
            <transition name="fade">
                <div v-if="countryBasinCropsLoader.status.loading" class="lottie">
                    <Lottie></Lottie>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import Table from "@/components/shared/Table.vue";
import Lottie from "@/components/shared/Lottie.vue";
import { assessment } from "@/services/assessment-model.js";
import { countryBasinCrops, countryBasinCropsLoader, getCountry, getBasin, getCrop } from "@/services/entity-model.js";
import { getFunctionGetCheckImage, getFunctionGetPercentageString, getWFtString, getWSString } from "@/services/data-tools.js";

export default {
    name: "GeographicSustainTableCt",
    components: {
        Table,
        Lottie
    },
    data() {
        return {
            assessment: assessment,
            countryBasinCrops: countryBasinCrops,
            countryBasinCropsLoader: countryBasinCropsLoader
        }
    },
    computed: {
        countryOrBasinText: function() {
            if ((assessment.assessmentType.name == "basins") && (assessment.countriesOrBasins.length == 1)) {
                return "country";
            }
            if ((assessment.assessmentType.name == "countries") && (assessment.countriesOrBasins.length == 1)) {
                return "river basin";
            }
            return "country and river basin";
        },
        rows: function() {
            return this.countryBasinCrops.filter(val => {
                const viewColor = this.assessment.viewColor;
                const viewColor1 = viewColor.replace("blue", "greenBlue");
                return (val[viewColor + "WF"] > 0) && (val[viewColor1 + "WFt"] > 0);
            });
        },
        columns: function() {
            const columns = [
                { key: "cropID", label: "Crop", dataFunction: function(val) { return getCrop(val).name; }},
                { key: "countryID", label: "Country", dataFunction: function(val) { return getCountry(val).name; }},
                { key: "basinID", label: "River Basin", dataFunction: function(val) { return !val? "(unknown basin)": getBasin(val).name; }}
            ];
            
            if (this.assessment.viewColor == "blue") {
                return columns.concat([
                    { key: "greenBlueWFt", label: "Green-Blue WF (m3/t)", dataFunction: getWFtString, classes: ["group", "left-row"] },
                    { key: "greenBlueWFt20", label: "Green-Blue Benchmark", dataFunction: getWFtString, classes: "group" },
                    { key: "greenBlueWFtExcess", label: "Deviation from Benchmark", dataFunction: getFunctionGetPercentageString(-1), classes: "group" },
                    { key: "greenBlueWFtSpot", label: "Efficiency", dataFunction: getFunctionGetCheckImage("Efficient"), classes: ["group", "right-row"] },
                    { key: "whiteSpace", label: "", classes: ["white-space"] },
                    { key: "blueWS", label: "Blue Water Scarcity", dataFunction: getWSString, classes: ["group", "left-row"] },
                    { key: "blueWSSpot", label: "Sustainability", dataFunction: getFunctionGetCheckImage("Sustainable"), classes: ["group", "right-row"] }
                ]);
            } else {  // grey
                return columns.concat([
                    { key: "greyWFt", label: "Grey WF (m3/t)", dataFunction: getWFtString, classes: ["group", "left-row"] },
                    { key: "greyWFt20", label: "Grey Benchmark", dataFunction: getWFtString, classes: "group" },
                    { key: "greyWFtExcess", label: "Deviation from Benchmark", dataFunction: getFunctionGetPercentageString(-1), classes: "group" },
                    { key: "greyWFtSpot", label: "Efficiency", dataFunction: getFunctionGetCheckImage("Efficient"), classes: ["group", "right-row"] },
                    { key: "whiteSpace", label: "", classes: ["white-space"] },
                    { key: "greyWS", label: "Water Pollution Level", dataFunction: getWSString, classes: ["group", "left-row"] },
                    { key: "greyWSSpot", label: "Sustainability", dataFunction: getFunctionGetCheckImage("Sustainable"), classes: ["group", "right-row"] }
                ]);
            }
        }
    }
}
</script>

